import React from 'react';

function Arrow({ direction }) {
  let svgArrow = (
    <svg
      width="17"
      height="10"
      viewBox="0 0 17 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M16 1L8.5 9L1 1" stroke="white" />
    </svg>
  );
  if (direction === 'right') {
    svgArrow = (
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M1 0.527832L9 8.02783L1 15.5278" stroke="white" />
      </svg>
    );
  }
  if (direction === 'left') {
    svgArrow = (
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M9 15.5278L1 8.02783L9 0.527832" stroke="white" />
      </svg>
    );
  }
  return svgArrow;
}

export default Arrow;
